module.exports = __webpack_public_path__ + "img/soar_old-min.81fc0560.png";